<template>
  <div v-if="show">
    <div class="tw-document-wrapper z-top controls-background">
      <div>
        <div
          class="card-header bg-white d-flex justify-content-between align-items-center pl-3 pr-2"
        >
          <div class="card-title mb-0 d-flex align-items-center">
            <span class="font-weight-bold"
              >{{ `${$t("printDocument.reference")}: ${reference}` }}
            </span>
          </div>
          <div class="card-title mb-0 d-flex align-items-end">
            <q-icon
              name="chevron_right"
              size="20px"
              @click="toggleShowControls"
            />
          </div>
        </div>
        <div class="row card-body tw-document-container scrollable-content">
          <div class="col-12">
          <!--### SEND MAIL  ### -->
            <q-expansion-item  
                 default-opened
                 switch-toggle-side header-class="card-header bg-transparent no-border p-4"
                 class="tw-items-dashed-group tw-items-group-with-bg tw-level-two-group" 
                 @show="isExpanded = true" 
                 @hide="isExpanded = false"
                 >
                <template v-slot:header>
                    <div class="card-title flex-grow-1 justify-content-between align-items-center mb-0">
                        <div class="d-flex align-items-center">
                            <div class="font-semi-bold font-size-12">
                              {{ $t("alertDialog.sendMail.title") }}
                            </div>
                        </div>
                    </div>
                </template>
                <div class="card-body">
                    <div class="p-0 bg-white default-border-radius mb-0">
                        <div class="d-flex">
                            <div class="flex-grow-1" >
                                 <div class="row">
                                    <div class="col-12">
                                        <MessageAlert  ref="alertMessage"/>
                                    </div>
                                  </div>
                            </div>
                        </div>
                    </div>
                </div>
            </q-expansion-item>

            <!--### ALERT HISTORY  ### -->
            <q-expansion-item  
                 default-opened
                 switch-toggle-side header-class="card-header bg-transparent no-border p-4"
                 class="tw-items-dashed-group tw-items-group-with-bg tw-level-two-group" 
                 @show="isExpanded = true" 
                 @hide="isExpanded = false"
                 >
                <template v-slot:header>
                    <div class="card-title flex-grow-1 justify-content-between align-items-center mb-0">
                        <div class="d-flex align-items-center">
                            <div class="font-semi-bold font-size-12">
                              {{ $t("alertDialog.alertHistory.title") }}
                            </div>
                        </div>
                    </div>
                </template>
                <div class="card-body">
                    <div class="p-2 bg-white default-border-radius mb-3">
                        <div class="d-flex">
                            <div class="flex-grow-1" >
                                 <div class="row">
                                    <div class="col-12">
                                          <div>
              <q-checkbox
                v-for="(item, index) in items"
                :key="index"
                v-model="item.selected"
                :label="$t('order.alertList.'.concat(item.name))"
              ></q-checkbox>
                                          </div>
                                          <q-input
                                            type="textarea"
                                            dense
                                            outlined
                                            :label="$t('Analysis.Comment')"
                                            class="w-100 mt-3"
                                            rows="1"
                                            v-model="comment"
                                          />
                                           <div class="text-right">
                                              <q-checkbox
                                                class="mr-2"
                                                v-model="showDeletedAlerts"
                                                :label="$t('main.dossier.asset.command.showDeletedAlerts')"
                                                @click="toggleShowDeletedAlerts"
                                              />
                                              <q-btn
                                                :label="$t('main.dossier.asset.command.add')"
                                                class="btn btn-primary"
                                                :disable="viewMode || !isAnyCheckboxSelected"
                                                @click="onSaveAlert"
                                              />
                                           </div>
                                           <div class="pt-0" >
                                              <div class="table-responsive">
                                                <div class="table-title">
                                                  <h5>{{ $t("order.alertList.title") }}</h5>
                                                </div>
                                         
                                                <q-table
                                                  class="shadow-0 table table-sm"
                                                  :rows="rows"
                                                  :columns="columns"
                                                  row-key="id"
                                                  :no-data-label="
                                                    $t('task.historiesStep.headers.histories.noDataMessage')
                                                  "
                                                >
                                                  <template v-slot:header="props">
                                                    <q-tr :props="props">
                                                      <q-th
                                                        v-for="col in props.cols"
                                                        :key="col.name"
                                                        :props="props"
                                                      >
                                                        {{ $t(col.label) }}
                                                      </q-th>
                                                      <q-th auto-width />
                                                    </q-tr>
                                                  </template>
                                                  <template v-slot:body="props">
                                                    <q-tr :props="props">
                                                      <q-td key="createdBy" :props="props">
                                                        {{ props.row.whoCreated }}
                                                      </q-td>
                                                      <q-td key="creationDate" :props="props">
                                                        {{ props.row.whenCreated }}
                                                      </q-td>
                                                      <q-td key="comment" :props="props">
                                                        {{ props.row.comment }}
                                                      </q-td>
                                                      <q-td key="reasons" :props="props">
                                                        {{ translateReasons(props.row.reasons) }}
                                                      </q-td>
                                                      <q-td auto-width>
                                                        <q-btn
                                                          v-if="!showDeletedAlerts"
                                                          flat
                                                          round
                                                          icon="delete"
                                                          color="red"
                                                          :disable="props.row.reasons === 'COMMISSION_MODIFIEE'
                                                          || connectedUser.username !== props.row.whoCreated"
                                                          @click="deleteAlert(props.row , props.rowIndex)"
                                                        />
                                                      </q-td>
                                                    </q-tr>
                                                  </template>
                                                </q-table>
                                              </div>
                                          </div>
                                            <div class="d-flex justify-content-end">
                                              <q-btn
                                                class="btn text-body mr-2"
                                                color="transparent"
                                                :label="$t('main.confirmationDialog.cancelButton')"
                                                @click="toggleShowControls"
                                              />
                                            </div>
                                    </div>
                                  </div>
                            </div>
                        </div>
                    </div>
                </div>
            </q-expansion-item>
          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import store from "@/store";
import { globalConfig} from "@/utils";
import moment from "moment";
import { ref } from "vue";
import { Options, Vue } from "vue-class-component";
import MessageAlert from "@/components/alert/MessageAlert.vue";
@Options({
  components: { MessageAlert }
})
export default class AlertDialog extends Vue {
  actionDate?: any = ref(moment().format("DD/MM/YYYY HH:mm"));
  comment = "";
  items?: any[] = [];
  checkedItems?: any = [];

  get showDeletedAlerts() {
    return store.state.orderModule.showDeletedAlerts;
  }
  get show() {
    return store.state.orderModule.showAlert;
  }
  get rows() {
    
    const rows = store.state.orderModule.alertList || []
    const showDeleted = store.state.orderModule?.showDeletedAlerts;
    const alerts = showDeleted === true ? rows.filter((alert:any) => alert && alert.alertValidity && alert.alertValidity.until !== null)
                        : showDeleted === false ? rows.filter((alert:any) => alert && alert.alertValidity && alert.alertValidity.until === null)
                        : []
    return alerts
  }

  get reference() {
    switch (this.currentRoute) {
      case "order-edit":
        return store.state.orderModule.order?.reference;
      case "TaskDetail":
        return store.state.taskModule.order?.reference;
    }
    return "-";
  }
  get order() {
     switch (this.currentRoute) {
      case "order-edit":
        return store.state.orderModule.order;
      case "TaskDetail":
        return store.state.taskModule.order;
      default:
        return store.state.orderModule.order;
    } 
  }
  async deleteAlert(row: any, index : number) {
    const deleteRow = { alert: row, orderId: this.order.resourceUid,  id: row.id };

   store.dispatch("showConfirmationDeleteDialog", {
      message: "Are you sure you want to delete this alert",
      confirmation: true,
      payload: deleteRow,
      deleteAction: "RemoveAlert",
    });


  }
  async onSaveAlert() {
    let reasonsList: any = [];
    if (this.items) {
      for (const item of this.items) {
        if (item.selected) reasonsList.push(item.name);
      }
    await  store.dispatch("orderModule/createOrderAlert", {
        orderId: this.order.resourceUid,
        reasons: reasonsList,
        comment: this.comment,
      });

    
   
      this.initializeCheckedItems();
    }
  }


  whoCreatedName() {
    const firstName = store.state.authModule?.user?.firstName || "";
    const lastName = store.state.authModule?.user?.lastName || "";
    return `${firstName} ${lastName}`.trim();
  }
  translateReasons(reasons:any) {
    if (!reasons) return '';
    const alerts = reasons.split(',');
    return alerts.map((alert: any) => this.$t(`order.alertList.${alert}`)).join(', ');
  }

  initializeCheckedItems() {
    this.items?.forEach((item: any) => {
      item.selected = false;
    });
    this.comment = "";
  }

  toggleShowControls() {
    this.initializeCheckedItems();
    return store.dispatch("orderModule/toggleShow");
  }
  async toggleShowDeletedAlerts() {
    const toggleShowDeletedAlerts = store.dispatch("orderModule/toggleShowDeletedAlerts");
    await store.dispatch("orderModule/getOrderAlertList", {
      filter: {
        orderId: this.order && this.order.resourceUid ? this.order.resourceUid : this.recoverState,
      },
    });
    return toggleShowDeletedAlerts;
  }

  get recoverState() {
     const orderState = localStorage.getItem(globalConfig.storageKeys.orderTask)
     const orderResourceUid = orderState ? JSON.parse(orderState).resourceUid : ""
    return orderResourceUid;
  }

  get columns() {
    return globalConfig.table_config.orderAlertCols;
  }

  get currentRoute() {
    return this.$router.currentRoute.value.name;
  }

  get getAlertList() {
    return store.state.orderModule.order?.alertList;
  }
  get isAnyCheckboxSelected() {
    const selectedItems = this.items?.filter((item: any) => item?.selected === true)
    return selectedItems && selectedItems.length > 0 ? true : false
  }
  created() {
   
    store.dispatch("orderModule/getAlertReasons", {
      callback: (res: any) => {
        if (res) {
          let itemsList: any = [];
          for (const item of res.items) {
            const reasons = { name: item.id, selected: false };
            if (reasons.name !== 'COMMISSION_MODIFIEE'){
              itemsList.push(reasons);
            }
          }
          this.items = itemsList;

          this.initializeCheckedItems();
        }
      },
    });
  }
  get viewMode() {
    return store.state.orderModule?.mode === "VIEW" || this.connectedUser.isAudit;
  }
  get connectedUser() {
    const user = store.getters["authModule/getUserConnected"];
    return {
      username: user.username,
      isAudit: user.authorities?.find(
        (el: { authority: string }) => el.authority === "ROLE_AUDITORS"
      ),
    };
  }
}
</script>


<style scoped>
.controls-background {
  background-color: white;
  border-radius: 10px;
  -webkit-box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
}
.scrollable-content {
  max-height: 800px; 
  overflow-y: auto;
}
</style>
